import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';

import { Icon, Typography } from '@seuk/design-system/atoms';

const ComponentContainer = styled.div`
  display: flex;
`;

const SectionName = styled.div``;

const CategoryLinks = styled.div`
  margin-top: ${({ theme }) => theme.spacing(6)};
`;

const IconContainer = styled.div`
  margin-right: ${({ theme }) => theme.spacing(4)};
`;

const ArticleLink = styled(Link)`
  color: ${({ theme }) => theme.palette.text.onSurface.strong};
  font-size: 18px;
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

interface Article {
  title: string;
  category: string;
  slug: string;
}

export interface CategorySectionData {
  name: string;
  label: string;
  href: string;
  parentName: string;
  index: number;
}

export interface CategorySectionProps {
  name: string;
  label: string;
  articles: Article[];
  onArticleClick: (linkData: CategorySectionData) => void;
}

export const CategorySection = ({ name, label, articles, onArticleClick }: CategorySectionProps) => {
  const router = useRouter();

  const onClickLocal = (article: Article, index: number) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    const target = e.currentTarget;

    onArticleClick({
      name: article.slug,
      href: target.href,
      label: article.title,
      parentName: name,
      index,
    });
  };

  return (
    <ComponentContainer>
      <IconContainer>
        <Icon name="ArrowForward" color="#FBCE07" width={30} height={30} />
      </IconContainer>
      <div>
        <SectionName>
          <Typography variant="h3">{label}</Typography>
        </SectionName>
        <CategoryLinks>
          {articles.map((article, idx) => (
            <ArticleLink
              href={`${router.asPath}/${article.slug}`}
              key={article.slug}
              onClick={onClickLocal(article, idx)}
            >
              {article.title}
            </ArticleLink>
          ))}
        </CategoryLinks>
      </div>
    </ComponentContainer>
  );
};
